import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
    actions: {
        async getTkoFractionsData(context) {
            const response = await Vue.axios.get(`${URL_API}tkofraction`);
            let data = response["data"];
            context.commit("updateTkoFractionsData", data);
        },
        async createTkoFractionData(context, name) {
            const config = {};
            const body = {
                name: name
            };
            await Vue.axios.post(`${URL_API}tkofraction/store`, body, config);
            context.dispatch("getTkoFractionsData");
        },
        async pushTkoFractionData(context, { id, name }) {
            const config = {};
            const body = {
                id: id,
                name: name
            };
            await Vue.axios.post(`${URL_API}tkofraction/update`, body, config);
            context.dispatch("getTkoFractionsData");
        },
        async destroyTkoFractionData(context, id) {
            const config = {};
            const body = {
                id: id
            };
            await Vue.axios.post(`${URL_API}tkofraction/destroy`, body, config);
            context.dispatch("getTkoFractionsData");
        }
    },
    mutations: {
        updateTkoFractionsData(state, tkoFractionsData) {
            state.tkoFractionsData = tkoFractionsData;
        }
    },
    state: {
        tkoFractionsData: []
    },
    getters: {
        allTkoFractionsData(state) {
            return state.tkoFractionsData;
        }
    }
};